/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import fetch from '../../client.ts';
import type { RequestConfig, ResponseErrorConfig } from '../../client.ts';
import type {
  TelegramProductsUserControllerFindAllPaginatedQueryResponse,
  TelegramProductsUserControllerFindAllPaginatedQueryParams,
  TelegramProductsUserControllerFindAllPaginated401,
} from '../types/TelegramProductsUserControllerFindAllPaginated.ts';

function getTelegramProductsUserFindAllPaginatedUrl() {
  const res = { method: 'GET', url: `/api/user/telegram/products/paginated` as const };
  return res;
}

/**
 * {@link /api/user/telegram/products/paginated}
 */
export async function telegramProductsUserFindAllPaginated(
  params?: TelegramProductsUserControllerFindAllPaginatedQueryParams,
  config: Partial<RequestConfig> & { client?: typeof fetch } = {},
) {
  const { client: request = fetch, ...requestConfig } = config;

  const res = await request<
    TelegramProductsUserControllerFindAllPaginatedQueryResponse,
    ResponseErrorConfig<TelegramProductsUserControllerFindAllPaginated401>,
    unknown
  >({ method: 'GET', url: getTelegramProductsUserFindAllPaginatedUrl().url.toString(), params, ...requestConfig });
  return res.data;
}
